const env = import.meta.env as Record<string, string | undefined>;

export const DAEMON_URL = (env.VITE_DAEMON_URL ?? "http://localhost:8787").replace(/\/$/, "");
export const DEFAULT_PROJECT = env.VITE_DEFAULT_PROJECT ?? "survivalcore";
